module.exports = __webpack_public_path__ + "static/img/practiceSystem_06.c9e9a9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/practiceSystem_06.png
// module id = PjVj
// module chunks = 23